module.exports = __webpack_public_path__ + "media/images/grey_logos/ny-times-428bcd9c33e678d20b9b312f7450fb21.svg";